<template>
	<div class="change_mode_alert">
		<div class="change_mode_wrap">
			<div class="change_mode_close" @click="onCancelClick"></div>
			<div
				:class="{ mode_icon: true, mode_icon_speed: modeType != 1 }"
			></div>
			<div class="mode_title">
				确定切换至【{{ modeType == 1 ? "普通模式" : "收益模式" }}】
			</div>
			<div class="mode_desc" v-if="modeType == 1">
				普通模式将不再享受积分奖励
			</div>
			<div class="mode_desc" v-else>开启收益模式可享受积分收益</div>
			<div class="mode_btns">
				<div class="mode_cancel_btn" @click="onCancelClick">取消</div>
				<div class="mode_sure_btn" @click="onSureClick">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	props: ["modeType"],
	methods: {
		...mapActions(["sendUserlog"]),
		onCancelClick: function () {
			let _that = this;
			_that.sendUserlog(["change_mode_cancel_click", _that.modeType]);
			_that.$emit("onCancelClick");
		},
		onSureClick: function () {
			let _that = this;
			_that.sendUserlog(["change_mode_sure_click", _that.modeType]);
			_that.$emit("onSureClick");
		},
	},
	mounted: function () {
		let _that = this;
		_that.sendUserlog(["change_mode", _that.modeType]);
	},
};
</script>

<style lang="less" scoped>
.change_mode_alert {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
	.change_mode_wrap {
		width: 300px;
		height: 306px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -150px;
		margin-top: -153px;
		border-radius: 5px;
		overflow: hidden;
		background-color: #fcfcfc;
		.change_mode_cancel {
			color: #999999;
			font-size: 12px;
			margin-left: 20px;
			margin-top: 15px;
		}
		.change_mode_cancel:hover {
			opacity: 0.8;
			cursor: pointer;
		}
		.change_mode_close {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 10px;
			top: 10px;
			background-image: url(../../assets/common/close4.svg);
			background-size: 100% 100%;
			cursor: pointer;
		}
		.change_mode_close:hover {
			opacity: 0.8;
			cursor: pointer;
		}
		.mode_icon {
			height: 58px;
			width: 58px;
			margin: 0 auto;
			margin-top: 50px;
			background-image: url("../../assets/speedShare/mode_normal_icon.svg");
			background-size: 100% 100%;
		}
		.mode_icon.mode_icon_speed {
			background-image: url("../../assets/speedShare/mode_speed_icon.svg");
		}
		.mode_title {
			font-size: 17px;
			color: #1a1a1a;
			text-align: center;
			font-weight: bolder;
			margin-top: 24px;
		}
		.mode_desc {
			margin: 0 auto;
			margin-top: 10px;
			width: 220px;
			font-size: 12px;
			color: #999999;
			text-align: center;
			font {
				font-size: 16px;
				vertical-align: text-bottom;
				margin: 0 2px;
				font-weight: bolder;
			}
		}

		.mode_btns {
			margin-top: 45px;
			text-align: center;
			.mode_sure_btn {
				display: inline-block;
				vertical-align: top;
			}
			.mode_cancel_btn {
				display: inline-block;
				vertical-align: top;
			}
		}

		.mode_sure_btn {
			margin: 0 auto;
			border-radius: 20px;
			width: 88px;
			height: 40px;
			line-height: 40px;
			margin-left: 15px;
			font-size: 14px;
			color: #fefefe;
			text-align: center;
			background-color: #1f5de3;
		}
		.mode_sure_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}

		.mode_cancel_btn {
			margin: 0 auto;
			border-radius: 20px;
			width: 88px;
			height: 40px;
			line-height: 40px;

			font-size: 14px;

			color: #fefefe;
			text-align: center;
			background-color: #949494;
		}
		.mode_cancel_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}
	}
}
</style>